"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSISTANT_TOPICS = void 0;
exports.ASSISTANT_TOPICS = [
    "campaign_setup",
    "tickets_events",
    "payouts",
    "stripe_verification",
    "account_access",
    "contacts_reports",
    "emails",
    "donor_receipt",
    "donor_refund",
    "unrecognized_charge",
    "recurring_donation",
    "prospect",
    "pricing",
    "integrations",
    "other",
];
